// Chart.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { generateChartData } from './generateChartData'
import { generateChartOptions } from './generateChartOptions';
// Registering necessary components in Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);


// Chart component to render individual chart
const Chart = ({ rawData, chartId }) => {
  const { additionalData } = generateChartData(rawData); // Extract additional data from chart data
  return (
    <div style={{maxHeight: 180 + 'px'}} key={chartId}>
      <Line className="chart-print"
        data={generateChartData(rawData)} 
        options={generateChartOptions(additionalData)} // Pass additionalData to options
      />
    </div>
  );
};

export default Chart;
